export const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white shadow-sm rounded-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-4">
              By accessing and using the Fáàrí platform, you accept and agree to be bound by the terms and provision of this agreement.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-4">2. User Accounts</h2>
            <p className="text-gray-700 mb-4">
              You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-4">3. Vendor Responsibilities</h2>
            <p className="text-gray-700 mb-4">
              Vendors must provide accurate product information and maintain quality standards for all listed items.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-4">4. Privacy Policy</h2>
            <p className="text-gray-700 mb-4">
              Your privacy is important to us. Please review our Privacy Policy to understand how we collect and use your information.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-6 mb-4">5. Contact Information</h2>
            <p className="text-gray-700 mb-4">
              For questions about these Terms of Service, please contact us at legal@faari.app
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;